import { makeStyles, Theme } from "@material-ui/core/styles";

export const useSharedCollectiblesStyles = makeStyles((theme: Theme) => ({
  indicatorsHeader: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 600,
    color: "#0F172A",
    marginTop: "40px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  infoIcon: {
    fontSize: theme.typography.pxToRem(19),
    fontWeight: 300,
    lineHeight: theme.typography.pxToRem(19),
    color: "#000",
    marginLeft: 10,
  },
  viewMoreBtn: {
    marginTop: "40px",
    fontfamily: "Inter !important",
    alignSelf: "right",
    justifySelf: "right",
    fontWeight: 600,
    color: "#F15A28",
    border: "none",
    backgroundColor: "transparent",
    fontSize: theme.typography.pxToRem(16),
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  mentorContainer: {
    marginTop: "30px",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "space-evenly",
    gap: "30px",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    flexBasis: "267px",
  },
  button: {
    marginBlockStart: 25,
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
  },
  tooltipTitle: {
    color: "#235693",
    fontFamily: "lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    margin: "4px 8px",
  },
}));
